module.exports = __webpack_public_path__ + "static/1-185ccc5df23e43fb9435918eb411b5e9.jpg";